module.exports = __webpack_public_path__ + "img/kn_add.53a7af97.svg";